import text from "../text";
export const uiRender = async (arg) => {
    const { schema } = arg;
    schema.appRender.text = "";
    await text.ui({ ...arg, value: schema.appRender.text });
};
//# sourceMappingURL=uiRender.js.map